import React, { Component } from "react";
import "../css/checkbox.css";
import Modal from 'react-modal';
import { FaStar, FaTimes, FaFacebook } from 'react-icons/fa';
import FloorplanImage from "./FloorplanImage";
import PhotoImage from "./PhotoImage";
import BuyOptions from "./BuyOptions";
import "react-dropdown/style.css";
import "../css/planPage.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ReactGA from 'react-ga';

import { css } from 'emotion';
import { ShareButtonRoundSquare, ShareBlockStandard } from 'react-custom-share';


class PlanPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            levels_1: false,
            levels_2: false,
            levels_3: false,
            levels_4: false,
            levels_5: false,
            beds_1: false,
            beds_2: false,
            beds_3: false,
            beds_4: false,
            beds_5: false,
            baths_1: false,
            baths_2: false,
            baths_3: false,
            baths_4: false,
            baths_5: false,
            sqft_min: "",
            sqft_max: "",
            style: "All",
            modalIsOpen: false,

            planId: "",//this is the planId being set from the SmallSearchResult component
            currentPlanLevels: "",
            currentPlanBeds: "",
            currentPlanBaths: "",
            currentPlanHalfBaths: "",
            currentPlanThreeQuarterBaths: "",
            currentPlanSqft: "",
            currentPlanFirstFloorSqft: "",
            currentPlanSecondFloorSqft: "",
            currentPlanThirdFloorSqft: "",
            currentPlanFourthFloorSqft: "",
            currentPlanWidth: "",
            currentPlanDepth: "",
            currentPlanFoundations: "",
            currentPlanGarageType: "",
            currentPlanRoofMaterial: "",
            currentPlanSidingMaterial: "",
            currentPlanEnergyEfficiency: "",
            currentPlanRidgeHeight: "",
            currentPlanRoofPitch: "",
            currentPlanMasterBedroomLocation: "",
            currentPlanParking: "",
            currentPlanParkingArea: "",


            offset: 0,
            resultData: [],
            collapsibleIsOpen: false,
            searchingById: false,
            searchPlanId: "",
            planImages: [],
            loadingImages: false,
            navTop: "52px",
            favButtonClicked: false,
            buyOptionsModalIsOpen: false
        };
    }

    render() {

        var shortDescription = "A " + this.randomDescriptionWord() + " " + this.state.currentPlanBeds + " bed, " + this.state.currentPlanBaths + " bath house plan from houseplanstore.com";

        const shareBlockProps = {
            url: 'https://www.houseplanstore.com/plans/types/houseplans/plan/' + this.props.planId,
            button: ShareButtonRoundSquare,
            buttons: [
                { network: 'Facebook', icon: FaFacebook },
            ],
            text: shortDescription,
        };


        var favoritesStorage = localStorage.getItem('favorites');
        var favButtonColor = "#4d4d4d";
        if (!!favoritesStorage) {
            if (favoritesStorage.includes(this.state.planId)) {
                favButtonColor = "#FFFD72";
            }
        }

        if (this.state.favButtonClicked == true) {
            favButtonColor = "#FFFD72";
        }

        return (
            <div style={{ overflow: "scroll", zIndex: 999, position: "fixed", top: 0, left: 0, right: 0, bottom: 0 }}>

                <div style={{ position: "absolute", height: 100 + "%", width: 100 + "%", top: "0px", backgroundColor: "#413618" }}></div>

                <div style={{ position: "relative" }}>

                    <div className="topBar">
                        <div onClick={() => {
                            var updateFunction = this.props.updateFunction;
                            updateFunction();
                            //window.scrollTo(0, 0);
                        }} className="topBarBackButton">
                            <FaTimes />
                        </div>
                        <div className="topBarTitle">{this.state.planId}</div>
                    </div>

                    <ToastContainer
                        position="top-center"
                        autoClose={1500}
                        hideProgressBar={true}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange={false}
                        draggable={false}
                        pauseOnHover={false}
                    />

                    <div className="mainPlanPageContentHolder">
                        {this.renderLoadingActInd()}
                        {this.state.planImages}
                    </div>

                    <div className="smallPlanInfo">
                        <div style={{ minWidth: "70px" }} className="infoSection"><strong>{this.state.planId}</strong></div>
                        <div className="infoSection">Levels: {this.state.currentPlanLevels}</div>
                        <div className="infoSection">Beds: {this.state.currentPlanBeds}</div>
                        <div className="infoSection">Baths: {this.state.currentPlanBaths}</div>
                        <div className="infoSection">Sqft. {this.state.currentPlanSqft} </div>
                    </div>

                    <div onClick={()=>{this.faceBookShareClicked()}} className="facebookHolder">
                        <ShareBlockStandard {...shareBlockProps} />
                    </div>

                    <div className="buttonHolder">
                        <div onClick={() => { this.openModal() }} className="detailButton">Details</div>
                        <div onClick={() => { this.openBuyOptionsModal() }} className="buyButton">Purchase</div>
                        <div onClick={() => { this.handleFavClick() }} style={{ color: favButtonColor }} className="favoriteButton"><FaStar /></div>
                    </div>

                    <Modal
                        isOpen={this.state.buyOptionsModalIsOpen}
                        ariaHideApp={false}
                        //onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeBuyOptionsModal}
                        style={{ overlay: { backgroundColor: "rgba(0, 0, 0, 0.6)" }, content: { zIndex: 9999 } }}
                        contentLabel="Buy"
                    >
                        <BuyOptions planId={this.state.planId} />
                    </Modal>

                    <Modal
                        isOpen={this.state.modalIsOpen}
                        ariaHideApp={false}
                        //onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeModal}
                        style={{ overlay: { backgroundColor: "rgba(0, 0, 0, 0.6)" }, content: { zIndex: 9999 } }}
                        contentLabel="Details"
                    >
                        <div style={{ fontFamily: 'EB Garamond', fontSize: "21px", fontWeight: "bold" }}>{this.state.planId}</div>
                        {this.renderPlanDetails()}
                    </Modal>

                </div >
            </div>
        );
    }

    faceBookShareClicked = () =>{
        ReactGA.event({
            category: 'User',
            action: 'Facebook Share Clicked',
            label: this.state.planId
        });
    }

    openModal = () => {
        this.setState({ modalIsOpen: true });
    }

    closeModal = () => {
        this.setState({ modalIsOpen: false });
    }

    openBuyOptionsModal = () => {
        this.setState({ buyOptionsModalIsOpen: true });
    }

    closeBuyOptionsModal = () => {
        this.setState({ buyOptionsModalIsOpen: false });
    }

    renderLoadingActInd = () => {
        if (this.state.loadingImages == true) {
            return (
                <div style={{ height: "40px", width: "40px", marginLeft: "auto", marginRight: "auto", marginTop: "30px" }}>
                    <img src={require('../images/rings.gif')} style={{ height: "40px", width: "40px" }} />
                </div>
            );
        } else {
            return null;
        }
    }

    renderPlanDetails = () => {
        var planHtml = [];
        if (this.state.currentPlanLevels !== "0" && !!this.state.currentPlanLevels) {
            planHtml.push(<div key={0} className="detailedInfoRow">Levels: <strong>{this.state.currentPlanLevels}</strong></div>);
        }
        if (this.state.currentPlanBeds !== "0" && !!this.state.currentPlanBeds) {
            planHtml.push(<div key={1} className="detailedInfoRow">Beds: <strong>{this.state.currentPlanBeds}</strong></div>);
        }
        if (this.state.currentPlanBaths !== "0" && !!this.state.currentPlanBaths) {
            planHtml.push(<div key={2} className="detailedInfoRow">Baths: <strong>{this.state.currentPlanBaths}</strong></div>);
        }
        if (this.state.currentPlanHalfBaths !== "0" && !!this.state.currentPlanHalfBaths) {
            planHtml.push(<div key={3} className="detailedInfoRow">Half Baths: <strong>{this.state.currentPlanHalfBaths}</strong></div>);
        }
        if (this.state.currentPlanThreeQuarterBaths !== "0" && !!this.state.currentPlanThreeQuarterBaths) {
            planHtml.push(<div key={4} className="detailedInfoRow">Three Quarter Baths: <strong>{this.state.currentPlanThreeQuarterBaths}</strong></div>);
        }
        if (this.state.currentPlanSqft !== "0" && !!this.state.currentPlanSqft) {
            planHtml.push(<div key={5} className="detailedInfoRow">Total Sqft: <strong>{this.state.currentPlanSqft}</strong></div>);
        }
        if (this.state.currentPlanFirstFloorSqft !== "0" && !!this.state.currentPlanFirstFloorSqft) {
            planHtml.push(<div key={6} className="detailedInfoRow">First Floor Sqft: <strong>{this.state.currentPlanFirstFloorSqft}</strong></div>);
        }
        if (this.state.currentPlanSecondFloorSqft !== "0" && !!this.state.currentPlanSecondFloorSqft) {
            planHtml.push(<div key={7} className="detailedInfoRow">Second Floor Sqft: <strong>{this.state.currentPlanSecondFloorSqft}</strong></div>);
        }
        if (this.state.currentPlanThirdFloorSqft !== "0" && !!this.state.currentPlanThirdFloorSqft) {
            planHtml.push(<div key={8} className="detailedInfoRow">Third Floor Sqft: <strong>{this.state.currentPlanThirdFloorSqft}</strong></div>);
        }
        if (this.state.currentPlanFourthFloorSqft !== "0" && !!this.state.currentPlanFourthFloorSqft) {
            planHtml.push(<div key={9} className="detailedInfoRow">Fourth Floor Sqft: <strong>{this.state.currentPlanFourthFloorSqft}</strong></div>);
        }
        if (this.state.currentPlanWidth !== "0" && !!this.state.currentPlanWidth) {
            planHtml.push(<div key={10} className="detailedInfoRow">Width: <strong>{this.state.currentPlanWidth}</strong></div>);
        }
        if (this.state.currentPlanDepth !== "0" && !!this.state.currentPlanDepth) {
            planHtml.push(<div key={11} className="detailedInfoRow">Depth: <strong>{this.state.currentPlanDepth}</strong></div>);
        }
        if (this.state.currentPlanFoundations !== "0" && !!this.state.currentPlanFoundations) {
            planHtml.push(<div key={12} className="detailedInfoRow">Foundations: <strong>{this.state.currentPlanFoundations.replace(/(^,)|(,$)/g, "")}</strong></div>);
        }
        if (this.state.currentPlanGarageType !== "0" && !!this.state.currentPlanGarageType) {
            planHtml.push(<div key={13} className="detailedInfoRow">Garage Type: <strong>{this.state.currentPlanGarageType.replace(/(^,)|(,$)/g, "")}</strong></div>);
        }
        if (this.state.currentPlanRoofMaterial !== "0" && !!this.state.currentPlanRoofMaterial) {
            planHtml.push(<div key={14} className="detailedInfoRow">Roof Material: <strong>{this.state.currentPlanRoofMaterial.replace(/(^,)|(,$)/g, "")}</strong></div>);
        }
        // if (this.state.currentPlanSidingMaterial !== "0" && !!this.state.currentPlanSidingMaterial) {
        //     planHtml.push(<div className="detailedInfoRow">Siding Material: <strong>{this.state.currentPlanSidingMaterial.replace(/(^,)|(,$)/g, "")}</strong></div>);
        // }
        if (this.state.currentPlanEnergyEfficiency !== "0" && !!this.state.currentPlanEnergyEfficiency) {
            planHtml.push(<div key={15} className="detailedInfoRow">Energy Efficiency: <strong>{this.state.currentPlanEnergyEfficiency}</strong></div>);
        }
        if (this.state.currentPlanRidgeHeight !== "0" && !!this.state.currentPlanRidgeHeight) {
            planHtml.push(<div key={16} className="detailedInfoRow">Ridge Height: <strong>{this.state.currentPlanRidgeHeight}</strong></div>);
        }
        if (this.state.currentPlanRoofPitch !== "0" && !!this.state.currentPlanRoofPitch) {
            planHtml.push(<div key={17} className="detailedInfoRow">Roof Pitch: <strong>{this.state.currentPlanRoofPitch}</strong></div>);
        }
        if (this.state.currentPlanMasterBedroomLocation !== "0" && !!this.state.currentPlanMasterBedroomLocation) {
            planHtml.push(<div key={18} className="detailedInfoRow">Master Bed Location: <strong>{this.state.currentPlanMasterBedroomLocation}</strong></div>);
        }
        if (this.state.currentPlanParking !== "0" && !!this.state.currentPlanParking) {
            planHtml.push(<div key={19} className="detailedInfoRow">Parking: <strong>{this.state.currentPlanParking}</strong></div>);
        }
        if (this.state.currentPlanParkingArea !== "0" && !!this.state.currentPlanParkingArea) {
            planHtml.push(<div key={20} className="detailedInfoRow">Parking Area: <strong>{this.state.currentPlanParkingArea}</strong></div>);
        }
        if (this.state.currentPlanDescription !== "0" && !!this.state.currentPlanDescription) {
            planHtml.push(<div key={21} className="detailedInfoRow"><br /> <strong>Description:</strong> <br /> {this.state.currentPlanDescription}</div>);
        }

        return planHtml;
    }

    getPlanInfo = () => {
        var url = "https://www.houseplanstore.com/web_api/?v=getPlanInfo&planId=" + this.state.planId;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = function (e) {
            try {
                var json = JSON.parse(xhr.responseText);
                this.setState({
                    currentPlanLevels: json.levels,
                    currentPlanBeds: json.bedrooms,
                    currentPlanBaths: json.bathrooms,
                    currentPlanHalfBaths: json.half_bathrooms,
                    currentPlanThreeQuarterBaths: json.three_quarter_bathrooms,
                    currentPlanSqft: json.total_sqft,
                    currentPlanFirstFloorSqft: json.first_floor_sqft,
                    currentPlanSecondFloorSqft: json.second_floor_sqft,
                    currentPlanThirdFloorSqft: json.third_floor_sqft,
                    currentPlanFourthFloorSqft: json.fourth_floor_sqft,
                    currentPlanWidth: json.width,
                    currentPlanDepth: json.depth,
                    currentPlanFoundations: json.foundation,
                    currentPlanGarageType: json.garage_type,
                    currentPlanRoofMaterial: json.roof_material,
                    currentPlanSidingMaterial: json.siding_material,
                    currentPlanEnergyEfficiency: json.energy_efficiency,
                    currentPlanRidgeHeight: json.ridge_height,
                    currentPlanRoofPitch: json.roof_pitch,
                    currentPlanMasterBedroomLocation: json.master_bedroom_location,
                    currentPlanParking: json.parking,
                    currentPlanParkingArea: json.parking_area,
                    currentPlanDescription: json.description,
                    favButtonClicked: false
                })
                this.renderPlanPhotos()
                
            } catch (err) {
                console.log(err);
            }
        }.bind(this)
        xhr.send();
    }

    renderPlanPhotos = () => {
        this.setState({ loadingImages: true });
        var url = "https://www.houseplanstore.com/web_api/?v=getPlanImages&planId=" + this.state.planId;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = function (e) {
            try {
                //console.log(xhr.responseText);
                if (xhr.responseText == "" || xhr.responseText == "null") {
                    return;
                }
                var json = JSON.parse(xhr.responseText);

                //make string of all images for gallery
                var allImages = json.main_image + "," + json.floorplan_images + json.other_images;

                var subImages = json.floorplan_images + json.other_images;
                var subImagesArray = subImages.split(",");
                subImagesArray.pop();

                var dataItems = [];
                //push main image first
                var shortDescription = "A " + this.randomDescriptionWord() + " " + this.state.currentPlanBeds + " bed, " + this.state.currentPlanBaths + " bath house plan from houseplanstore.com";
                dataItems.push(<PhotoImage key={0} shortDescription={shortDescription} planId={this.state.planId} image={"https://www.houseplanstore.com/media/" + json.main_image} images={allImages} index={0} />);
                for (var i = 0; i < subImagesArray.length; i++) {
                    shortDescription = "A " + this.state.currentPlanBeds + " Bed, " + this.state.currentPlanBaths + " Bath " + this.randomDescriptionWord() + " house plan from houseplanstore.com";
                    if (subImagesArray[i].includes("floorplan")) {
                        dataItems.push(<FloorplanImage key={i + 1} shortDescription={shortDescription} planId={this.state.planId} image={"https://www.houseplanstore.com/media/" + subImagesArray[i]} images={allImages} index={i + 1} />);
                    } else {
                        dataItems.push(<PhotoImage key={i + 1} shortDescription={shortDescription} planId={this.state.planId} image={"https://www.houseplanstore.com/media/" + subImagesArray[i]} images={allImages} index={i + 1} />);
                    }
                }

                this.setState({ planImages: [...this.state.planImages, ...dataItems], loadingImages: false });

            } catch (err) {
                console.log(err);
            }
        }.bind(this)
        xhr.send();
    }

    randomDescriptionWord = () => {
        var words = [
            'beautiful',
            'wonderful',
            'charming',
            'stunning',
            'gorgeous'
        ];
        var randomIndex = Math.floor(Math.random() * 10) % words.length;
        return words[randomIndex];
    }

    handleFavClick = () => {
        this.setState({
            favButtonClicked: true
        });
        var planIds = localStorage.getItem('favorites');
        if (!!planIds) {
            if (!planIds.includes(this.state.planId)) {
                planIds = planIds + this.state.planId + ",";
                localStorage.setItem('favorites', planIds);
            }
        } else {
            localStorage.setItem('favorites', this.state.planId + ",");
        }

        ReactGA.event({
            category: 'User',
            action: 'Added Favorite',
            label: this.state.planId
        });


        toast.info('Plan ' + this.state.planId + ' added to favorites.', {
            position: "top-center",
            autoClose: 1500,
            bodyClassName: "toastFont",
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false
        });
    }

    onStyleChange = option => {
        this.setState({ style: option.label });
        this.applySearchResults();
    };

    applySearchResults = () => {
        this.setState({
            resultData: [],
            offset: 0,
            collapsibleIsOpen: false,
            searchingById: false,
        });
        setTimeout(() => {
            this.getSearchResults("first");
        }, 300);

    }

    getUrlVars = () => {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    }

    componentDidMount() {
        //if (!!this.getUrlVars()["planId"]) {
        //this.setState({ planId: this.getUrlVars()["planId"] });
        this.setState({ planId: this.props.planId });
        setTimeout(() => {
            //this.renderPlanPhotos();
            this.getPlanInfo();
            document.body.classList.add('modal-open');
        }, 300)
        ReactGA.pageview('/webapp/plans/'+this.props.planId);
        //}

    }

    componentWillUnmount() {
        document.body.classList.remove('modal-open');
    }

}

export default PlanPage;
